module.exports = __webpack_public_path__ + "fontawesome-webfont.woff2?af7ae505a9eed503f8b8e6982036873e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 721
// module chunks = 27